import * as actions from '../actions/actionTypes';

const initialState = {
  locations: [],
  locationData: null,
}

const fetchLocationsSuccess = (state, action) => {
  return { ...state, locations: action.locations }
}

const fetchLocationSuccess = (state, action) => {
  return { ...state, locationData: action.locationData }
}

const createLocationSuccess = (state, action) => {
  return { ...state }
}

const updateLocationSuccess = (state, action) => {
  return { ...state }
}

const deleteLocationSuccess = (state, action) => {
  const newLocations = state.locations.filter(
    (location) => location.id !== action.id
  );
  return {
    ...state,
    locations: newLocations
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_LOCATIONS_SUCCESS: return fetchLocationsSuccess(state, action);
    case actions.DELETE_LOCATION_SUCCESS: return deleteLocationSuccess(state, action);
    case actions.CREATE_LOCATION_SUCCESS: return createLocationSuccess(state, action);
    case actions.FETCH_LOCATION_SUCCESS: return fetchLocationSuccess(state, action);
    case actions.UPDATE_LOCATION_SUCCESS: return updateLocationSuccess(state, action);

    default: return state;
  }
}

export default reducer;